'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export function NProgressBar() {
  const pathname = usePathname()

  useEffect(() => {
    NProgress.configure({
      showSpinner: false,
      easing: 'ease',
      speed: 500,
      minimum: 0.1,
      trickle: true,
      trickleSpeed: 200,
    })

    const handleStart = () => NProgress.start()
    
    const handleDone = () => setTimeout(() => NProgress.done(), 100)

    handleStart()

    const timeout = setTimeout(handleDone, 5000) // Fallback timeout

    return () => {
      clearTimeout(timeout)
      handleDone()
    }
  }, [pathname]) // Removed searchParams dependency

  return null
}